import styled from 'styled-components';

export default styled.main`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  padding: 20px 16px 30px;
  overflow: auto;

  h2 {
    font-size: 20px;
    line-height: 1.5;
  }
`;
